import {
	InputSwitch,
	type InputSwitchChangeEvent,
} from 'primereact/inputswitch';
import type { Dispatch, SetStateAction } from 'react';
import styles from './switch-button.module.css';

type Props = {
	checked: boolean;
	setChecked: Dispatch<SetStateAction<boolean>>;
	disabled?: boolean;
};

const SwitchButton = ({ checked, setChecked, disabled }: Props) => {
	return (
		<InputSwitch
			checked={checked}
			disabled={disabled}
			onChange={(e: InputSwitchChangeEvent) => setChecked(e.target.value)}
			pt={{
				slider: {
					className: checked
						? styles.switchSliderOn
						: styles.switchSliderOff,
				},
			}}
		/>
	);
};

export default SwitchButton;
